/*
行政管理接口
*/
import request from '@/utils/request'
import base from './base';

// 使用基础 API 地址
export const host = base.api_data;

// API 端点定义

const api_license_search = '/administration/search/';// 营业执照查询
const api_license_check = '/administration/license_check/';// 营业执照校验
const api_license_save = '/administration/save/';// 新增和修改合同
const api_license_action = '/administration/action/';// 查找合同id，和删除
const api_license_upload_image = '/administration/uploadImage/';// 合同上传图片
const api_license_updateAvatar = '/administration/updateAvatar/'; // 更新图片
const api_license_template = '/administration/template/'; // 下载模板
const api_license_batch_add = '/administration/batch_add/';// 批量导入合同
// 导出API方法
export default {
    baseurl: host,
    // 获取营业执照列表
    // 搜索营业执照
    api_license_search(params) {
        return request.post(`${host}${api_license_search}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 获取单个执照详情
    api_license_check(params) {
        return request.post(`${host}${api_license_check}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 保存执照
    api_license_save(params) {
        return request.post(`${host}${api_license_save}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    api_license_action(params, method = 'delete') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_license_action}`, { data: params });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_license_action}?${queryString}`);
        }
    },
    api_license_upload_image(params) {
        return request.post(`${host}${api_license_upload_image}`, params);
    },
    api_license_updateAvatar(params) {
        console.log("打印参数--finance.js", params);
        return request.post(`${host}${api_license_updateAvatar}`, params, { headers: { 'Content-Type': 'multipart/form-data' } });
    },
    api_license_template() {
        return request.get(`${host}${api_license_template}`, {
            responseType: 'blob'
        });
    },
    api_license_batch_add(formData) {
        return request.post(`${host}${api_license_batch_add}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
}
